import { Tool } from '../../types';

export const communicationTools: Tool[] = [
  {
    id: 'slack',
    name: 'Slack',
    category: 'Communication',
    description: 'Leading business communication platform that organizes conversations into searchable channels. Features direct messaging, huddles for quick calls, workflow automation, and 2400+ app integrations. The modern alternative to email for team collaboration.',
    pricing: ['free', 'medium', 'high'],
    features: ['ease-of-use', 'mobile', 'integrations', 'security'],
    bestFor: ['startup', 'small-business', 'freelancer'],
    compatibleWith: ['agency', 'service-business', 'saas'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'creative', 'marketing'],
    website: 'https://slack.com',
    imageUrl: 'https://logo.clearbit.com/slack.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'discord',
    name: 'Discord',
    category: 'Communication',
    description: 'Voice, video, and text communication platform originally for gamers, now popular with businesses and communities. Create servers with organized channels, host live events, and build engaged communities around your brand or product.',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['content-creator', 'agency'],
    goals: ['streamline-operations', 'enhance-customer-service'],
    industries: ['technology', 'creative', 'gaming'],
    website: 'https://discord.com',
    imageUrl: 'https://logo.clearbit.com/discord.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'zoom',
    name: 'Zoom',
    category: 'Communication',
    description: 'Industry-standard video conferencing platform for meetings, webinars, and virtual events. Crystal-clear video quality, screen sharing, breakout rooms, and recording capabilities. Integrates with calendars and productivity tools seamlessly.',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['consulting-firm', 'service-business'],
    goals: ['enhance-customer-service', 'streamline-operations'],
    industries: ['education', 'consulting', 'technology'],
    website: 'https://zoom.us',
    imageUrl: 'https://logo.clearbit.com/zoom.us',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  }
];